import React, { useState, useEffect } from "react";
import Menu from "../Menu"; // Assuming you have a Menu component in your project

const Send = () => {
  const [socket, setSocket] = useState(null);
  const [merchantName, setMerchantName] = useState("M4");
  const [key, setKey] = useState("key4");
  const [posName, setPosName] = useState("7");
  const [msg, setMsg] = useState("Test connection");
  const [allMsg, setAllMsg] = useState("");
  const [clients, setClients] = useState([]);
  const [messageLog, setMessageLog] = useState([]); // State to store message log

  useEffect(() => {
    // Create WebSocket connection
    const ws = new WebSocket("ws://157.90.147.8:9500");
    setSocket(ws);

    // Handle WebSocket events
    ws.onopen = () => {
      console.log("WebSocket connected to ws://157.90.147.8:9500");
    };

    ws.onmessage = (event) => {
      try {
        const parsedData = JSON.parse(event.data);
        setMessageLog((prevLog) => [
          ...prevLog,
          { type: "received", data: parsedData },
        ]); // Log received message

        if (parsedData.action === "clientsmap") {
          setClients(parsedData.data); // Update clients state
        }
      } catch (e) {
        console.error("Error parsing message:", e);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket connection error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed.");
    };

    // Cleanup WebSocket connection on component unmount
    return () => {
      ws.close();
    };
  }, []);

  const sendLoginData = () => {
    const data = {
      Action: "login",
      MerchantName: merchantName,
      Key: key,
      PosName: posName,
      Msg: msg,
    };
    socket.send(JSON.stringify(data));
    setMessageLog((prevLog) => [
      ...prevLog,
      { type: "sent", data: data },
    ]); // Log sent message

    // Clear the msg field after sending the message
    setMsg("");
  };

  const requestClientsMap = () => {
    const data = { Action: "getclientsmap" };
    socket.send(JSON.stringify(data));
    setMessageLog((prevLog) => [
      ...prevLog,
      { type: "sent", data: data },
    ]); // Log sent message
  };

  const sendMessageToAll = () => {
    const data = {
      Action: "message",
      target: "all",
      Msg: allMsg,
    };
    socket.send(JSON.stringify(data));
    setMessageLog((prevLog) => [
      ...prevLog,
      { type: "sent", data: data },
    ]); // Log sent message

    // Clear the allMsg field after sending the message
    setAllMsg("");
  };

  const sendMessageToClient = (clientKey, message) => {
    const data = {
      Action: "message",
      target: clientKey,
      Msg: message,
    };
    socket.send(JSON.stringify(data));
    setMessageLog((prevLog) => [
      ...prevLog,
      { type: "sent", data: data },
    ]); // Log sent message

    // Clear the individual client message input after sending
    document.getElementById(`msg-${clientKey}`).value = "";
  };

  // Function to clear the message log
  const clearLog = () => {
    setMessageLog([]); // Clear the log by resetting the state
  };

  return (
    <>
      <Menu /> {/* Sidebar menu included */}

      <div className="content-wrapper" style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* WebSocket Connection Test Form */}
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              width: "48%", // Adjusted to take up 48% of the width
            }}
          >
            <h4>WebSocket Connection Test</h4>

            <div className="form-group">
              <label>Merchant Name</label>
              <input
                type="text"
                className="form-control"
                id="merchantName"
                value={merchantName}
                onChange={(e) => setMerchantName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Key</label>
              <input
                type="text"
                className="form-control"
                id="key"
                value={key}
                onChange={(e) => setKey(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>POS Name</label>
              <input
                type="text"
                className="form-control"
                id="posName"
                value={posName}
                onChange={(e) => setPosName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <input
                type="text"
                className="form-control"
                id="msg"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <button className="btn btn-primary" onClick={sendLoginData}>
                Login
              </button>
              <button className="btn btn-success" onClick={requestClientsMap}>
                Get Clients Map
              </button>
            </div>
          </div>

          {/* Message Log Box */}
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              width: "48%", // Adjusted to take up 48% of the width
            }}
          >
            <h4>Message Log</h4>
            <ul style={{ maxHeight: "400px", overflowY: "scroll" }}>
              {messageLog.map((log, index) => (
                <li key={index}>
                  <strong>{log.type === "sent" ? "Sent" : "Received"}:</strong>{" "}
                  <pre>{JSON.stringify(log.data, null, 2)}</pre>
                </li>
              ))}
            </ul>

            {/* Clear Log Button */}
            <button
              className="btn btn-danger"
              onClick={clearLog}
              style={{ width: "100%", marginTop: "10px" }}
            >
              Clear Log
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="form-group">
                  <label>Message to All:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="allMsg"
                    value={allMsg}
                    onChange={(e) => setAllMsg(e.target.value)}
                  />
                </div>
                <button
                  className="btn btn-warning"
                  onClick={sendMessageToAll}
                  style={{ width: "100%" }}
                >
                  Send to All
                </button>
              </div>
            </div>

            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="card">
                  <div className="card-header"></div>

                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th>Key</th>
                          <th>Message</th>
                          <th>Send</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clients.length > 0 ? (
                          clients.map((clientKey, index) => (
                            <tr key={index}>
                              <td>{clientKey}</td>
                              <td>
                                <input type="text" id={`msg-${clientKey}`} />
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    sendMessageToClient(
                                      clientKey,
                                      document.getElementById(
                                        `msg-${clientKey}`
                                      ).value
                                    )
                                  }
                                >
                                  Send
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                              No clients connected
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Send;
